(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-feature-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const node = document.getElementById('BBFeatureAnalyticsConfig');
  if (!node || node.dataset.initialized) return;
  node.dataset.initialized = 'true';
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const debug = new URLSearchParams(location.search).get('bb_analytics_debug');
  const preview = window.Shopify?.theme?.role !== 'main' || window.Shopify?.designMode === true;
  const environment = preview ? 'preview' : 'live';
  const log = (status, event, params = {}) => {
    if (debug) console.info('[BB analytics]', JSON.stringify({status, event, ...params}));
  };
  // Draft browsing is silent by default; explicit QA can use GA4 DebugView.
  if (preview && !debug) return;
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  };
  const base = () => ({
    theme_version: config.version, theme_environment: environment,
    page_type: config.page_type, collection_handle: config.collection,
    send_to: config.measurement_id,
    // No search strings, phone numbers, email, full referrer or form text.
    page_location: location.origin + location.pathname,
    page_referrer: (() => { try { const u = new URL(document.referrer); return u.origin + u.pathname; } catch (_) { return ''; } })(),
    ...(debug ? {debug_mode: true} : {})
  });
  function send(event, params = {}) {
    if (!allowed()) { log('consent_blocked', event); return false; }
    const payload = {...base(), ...params};
    if (debug === 'local') { log('local_only', event, payload); return true; }
    // The channel owns initialization/configuration and ecommerce. Only enqueue
    // on its existing dataLayer once its loader is present; fail closed otherwise.
    const ready = Array.from(document.scripts).some(s => s.src.includes('googletagmanager.com/gtag/js') && s.src.includes(config.measurement_id));
    if (!ready || !Array.isArray(window.dataLayer)) { log('tag_not_ready', event); return false; }
    const push = function() { window.dataLayer.push(arguments); };
    push('event', event, payload);
    log('queued_to_existing_tag', event, payload);
    return true;
  }
  const features = [
    ['.bb-campaign__slide', 'hero_carousel'],
    ['.bb-campaign__size-band,.bb-home__size-band', 'size_banner'],
    ['.bb-home__category-card', 'category_carousel'],
    ['.bb-compact__card', 'compact_product_edit'],
    ['.bb-editorial', 'editorial_product'],
    ['.bb-home__product-card', 'homepage_bestsellers'],
    ['bb-up-close', 'up_close'],
    ['.bb-header-nav', 'header_categories'],
    ['.bb-campaign__size-band', 'size_navigation'],
    ['.bb-belief__size-art', 'shop_by_size'],
    ['.bb-belief__card', 'brand_benefits'],
    ['.bb-marquee', 'usp_scroller'],
    ['.bb-home__fit-panel', 'fit_story'],
    ['bb-size-browser', 'collection_size_filter'],
    ['bb-collection-card', 'collection_product'],
    ['.facets-container', 'collection_filters'],
    ['.bb-pdp-sticky', 'sticky_add_to_cart'],
    ['bb-size-dialog dialog', 'size_guide'],
    ['bb-size-finder', 'size_finder'],
    ['.bb-discovery-related', 'related_styles'],
    ['.bb-discovery-unavailable', 'sold_out_alternatives'],
    ['.bb-discovery-low', 'stock_notice'],
    ['.bb-discovery-facts', 'product_facts'],
    ['.bb-pdp-assurance', 'product_assurance'],
    ['.bb-pdp-fit', 'fit_help'],
    ['.bb-pdp-nav', 'product_navigation'],
    ['variant-selects', 'product_options'],
    ['product-form', 'product_purchase'],
    ['.bb-brand-note', 'brand_note'],
    ['.product__description', 'product_description']
  ];
  const selector = features.map(x => x[0]).join(',');
  const seen = new Set();
  const observed = new WeakSet();
  const timers = new Map();
  const visible = new Set();
  const lastUse = new Map();
  let themeViewed = false;
  let pendingCart = null;
  const clean = value => String(value || '').slice(0,100);
  const size = value => /^(?:[2-9]|1[0-2])?X{0,4}[SML]$/i.test(String(value || '').trim()) ? String(value).trim().toUpperCase() : '';
  function context(el, forcedFeature) {
    const container = el.closest(selector);
    const feature = forcedFeature || features.find(([s]) => container?.matches(s))?.[1] ||
      (el.closest('.bb-belief') ? 'shop_by_size' : el.closest('.bb-compact') ? 'compact_product_edit' : el.closest('bb-scroll-carousel')?.hasAttribute('data-categories') ? 'category_carousel' : el.closest('bb-scroll-carousel') ? 'hero_carousel' : 'product_details');
    const section = el.closest('.shopify-section');
    const link = el.closest('a[href]') || container?.querySelector('a[href*="/products/"]');
    let destination = '', variant = '', chosen = '';
    if (link) try {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin) {
        destination = url.pathname;
        variant = /^\d+$/.test(url.searchParams.get('variant') || '') ? url.searchParams.get('variant') : '';
        chosen = (url.searchParams.get('filter.v.option.size') || '').split(',').map(size).filter(Boolean).join(',');
      } else if (/^(?:wa.me|api.whatsapp.com)$/.test(url.hostname)) destination = 'whatsapp';
    } catch (_) {}
    const card = el.closest('bb-collection-card');
    const modalProduct = el.closest('quick-add-modal')?.id.match(/^QuickAdd-(\d+)$/)?.[1];
    const product = card?.dataset.productId || modalProduct ||
      (!destination.includes('/products/') || destination.endsWith('/'+config.product_handle) ? config.product_id : '');
    chosen = chosen || size(el.closest('product-info')?.querySelector('bb-product-discovery[data-mode="stock"]')?.dataset.size) ||
      (card ? (document.querySelector('bb-size-browser')?.dataset.size || '').split(',').map(size).filter(Boolean).join(',') : '');
    const form = el.closest('bb-up-close,product-info,quick-add-modal')?.querySelector('form[action*="/cart/add"]');
    variant = variant || form?.querySelector('[name="id"]')?.value || '';
    return {
      feature_name: feature,
      feature_placement: clean(section?.id || (el.closest('quick-add-modal') ? 'quick_view' : config.page_type)),
      ...(destination ? {destination_path: clean(destination)} : {}),
      ...(destination.includes('/products/') ? {product_handle:clean(destination.split('/products/')[1])} : {}),
      ...(product ? {product_id: clean(product)} : {}),
      ...(card ? {availability:card.classList.contains('bb-card--sold')?'sold_out':'in_stock'} : {}),
      ...(variant ? {variant_id: clean(variant)} : {}),
      ...(chosen ? {selected_size: clean(chosen)} : {})
    };
  }
  function use(el, action, extra = {}, forcedFeature) {
    const params = {...context(el, forcedFeature), feature_action: action, ...extra};
    if (action === 'option_select' || action === 'chart_size_select') delete params.variant_id;
    const key = JSON.stringify(params);
    const now = Date.now();
    if (now - (lastUse.get(key) || 0) < 350) return;
    lastUse.set(key, now);
    if (lastUse.size > 150) lastUse.delete(lastUse.keys().next().value);
    send('bb_feature_use', params);
    if (action === 'add_to_cart_click' && allowed()) pendingCart = {at: now, ...params};
  }
  function exposure(el) {
    if (!el.isConnected || document.hidden || el.closest('[hidden],[inert]')) return;
    const params = context(el);
    const index = el.parentElement ? Array.from(el.parentElement.children).indexOf(el) + 1 : 1;
    params.feature_position = index;
    const key = JSON.stringify(params);
    if (!seen.has(key) && send('bb_feature_view', params)) seen.add(key);
  }
  function arm(el) {
    if (timers.has(el) || document.hidden) return;
    timers.set(el, setTimeout(() => { timers.delete(el); if (visible.has(el)) exposure(el); }, 1000));
  }
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const area = entry.intersectionRect.width * entry.intersectionRect.height;
      const required = Math.min(entry.boundingClientRect.width * entry.boundingClientRect.height, innerWidth * innerHeight) * 0.5;
      if (entry.isIntersecting && area >= required) { visible.add(entry.target); arm(entry.target); }
      else { visible.delete(entry.target); clearTimeout(timers.get(entry.target)); timers.delete(entry.target); }
    });
  }, {threshold: [0,0.1,0.25,0.5,0.75,1]}) : null;
  function scan(root = document) {
    const list = [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
    list.forEach(el => { if (!observed.has(el)) { observed.add(el); observer?.observe(el); } });
  }
  function start() {
    if (!themeViewed) themeViewed = send('bb_theme_view');
    visible.forEach(arm);
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (!allowed()) { pendingCart = null; timers.forEach(clearTimeout); timers.clear(); return; }
    start();
  });
  document.addEventListener('visibilitychange', () => {
    timers.forEach(clearTimeout); timers.clear();
    if (!document.hidden) start();
  });
  // Capture genuine interactions only. Programmatic carousel advance, default
  // chart-tab selection and the sticky button's native-button proxy are excluded.
  document.addEventListener('click', event => {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    const el = event.target.closest('a,button,summary,[role="tab"],[data-bb-chart-row]');
    if (!el || el.matches(':disabled,[aria-disabled="true"]')) return;
    if (el.matches('[data-bb-feature]')) return use(el,'link_click',{},el.dataset.bbFeature);
    if (el.matches('[data-bb-guide]')) return; // Count actual dialog open below.
    if (el.matches('[data-bb-buy]')) return use(el,'add_to_cart_click',{},'sticky_add_to_cart');
    if (el.matches('[data-bb-options]')) return use(el,'change_size',{},'sticky_add_to_cart');
    if (el.matches('[data-bb-mix]')) return use(el,'mix_match_help',{},'fit_help');
    if (el.matches('[data-bb-image-toggle],[data-swap]')) return use(el,'image_swap');
    if (el.matches('[data-bb-chart-row]')) { const choice = el.querySelector('[data-bb-chart-select]'); if (choice && !choice.disabled) return use(choice,'chart_size_select',{selected_size:size(choice.dataset.bbChartSelect),selection_source:'table'},'size_guide'); return; }
    if (el.matches('[data-bb-chart-select]')) return use(el,'chart_size_select',{selected_size:size(el.dataset.bbChartSelect),selection_source:'table'},'size_guide');
    if (el.matches('[data-bb-chart-close]')) return use(el,'close',{},'size_guide');
    if (el.matches('[data-bb-chart-compare] > summary')) return use(el,el.parentElement.open?'compare_close':'compare_open',{},'size_guide');
    if (el.matches('.srv-tab')) return use(el,'category_tab',{option_value: clean(el.dataset.p)},'size_guide');
    if (el.matches('[data-autoplay-toggle]')) return use(el,el.dataset.state === 'playing' ? 'pause' : 'play',{},'hero_carousel');
    if (el.matches('[data-prev],[data-next],[data-slide]')) return use(el,el.hasAttribute('data-slide')?'slide_select':el.hasAttribute('data-next')?'next':'previous',{...(el.hasAttribute('data-slide')?{feature_position:Number(el.dataset.slide)+1}:{})});
    if (el.matches('.bb-sf__retry')) return use(el,'retry',{},'size_finder');
    if (el.matches('[data-size]')) return use(el,'size_select',{selected_size:size(el.dataset.size)});
    if (el.matches('.quick-add__submit[data-product-url]')) return use(el,'quick_view_click',{},'quick_view');
    if (el.matches('.product-form__submit,[data-add]')) return use(el,'add_to_cart_click');
    if (el.matches('summary')) {
      if (el.closest('.bb-sf__panel')) return; // Actual open below.
      if (el.closest('.bb-pdp-terms')) return use(el,'terms_toggle',{},'product_assurance');
      if (el.closest('.bb-belief__more-sizes')) return use(el,'more_sizes_toggle',{},'shop_by_size');
      if (el.closest('.facets-container')) return use(el,'filter_panel_toggle',{},'collection_filters');
      if (el.closest('product-info,.product__accordion,.product__description')) return use(el,'details_toggle');
      return;
    }
    if (el.matches('a')) {
      if (el.closest('.bb-plp-sizes')) return use(el,'size_filter',{},'collection_size_filter');
      if (el.matches('.bb-plp-stock')) return use(el,'stock_filter',{option_value:el.getAttribute('aria-pressed') === 'true'?'in_stock_only':'include_sold_out'},'collection_size_filter');
      if (el.closest('facet-remove')) return use(el,'remove_filter',{},'collection_filters');
      if (el.closest('.bb-sf__results')) return use(el,'result_click',{},'size_finder');
      if (el.closest('.bb-belief__sizes')) return use(el,'size_filter',{},'shop_by_size');
      if (el.matches('a[href*="wa.me"],a[href*="api.whatsapp.com"]') && el.closest('product-info,.product__description')) return use(el,'fit_contact',{},'fit_help');
      if (el.closest(selector) || el.closest('.bb-belief,.bb-campaign__controls,.bb-home__category-controls,.bb-close__help')) return use(el,'link_click');
    }
  }, true);
  document.addEventListener('change', event => {
    const el = event.target;
    if (!event.isTrusted || !(el instanceof Element)) return;
    if (el.matches('[data-bb-chart-size-select]')) return use(el,'chart_size_select',{selected_size:size(el.value),selection_source:'selector'},'size_guide');
    if (el.closest('facet-filters-form')) {
      const name = el.name || '';
      if (name === 'sort_by') return use(el,'sort',{option_value:clean(el.value)},'collection_filters');
      if (name.startsWith('filter.')) return use(el,'filter_change',{filter_name:clean(name),...(name==='filter.v.option.size'?{selected_size:size(el.value)}:{}),filter_state:el.type==='checkbox'?(el.checked?'on':'off'):'changed'},'collection_filters');
    }
    if (el.closest('variant-selects') || el.matches('bb-up-close select[data-option-index]')) {
      const value = el.value || '';
      use(el,'option_select',size(value)?{selected_size:size(value)}:{option_value:clean(value)});
    }
  }, true);
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.bb-sf__panel')) use(event.target,event.target.open?'open':'close',{},'size_finder');
  }, true);
  // Manual horizontal scrolling, not timed movement, is feature usage.
  const scrolling = new WeakMap();
  document.addEventListener('pointerdown', event => {
    const track = event.target.closest?.('bb-scroll-carousel [data-track]');
    if (track && event.isTrusted) scrolling.set(track,{left:track.scrollLeft,at:Date.now(),reported:false});
  }, {passive:true,capture:true});
  document.addEventListener('scroll', event => {
    const track = event.target;
    const state = scrolling.get(track);
    if (state && !state.reported && Date.now()-state.at<2500 && Math.abs(track.scrollLeft-state.left)>40) {
      state.reported=true;use(track,'swipe');
    }
  }, {passive:true,capture:true});
  const mutations = new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') {
        record.addedNodes.forEach(n => { if (n instanceof Element) scan(n); });
        record.removedNodes.forEach(n => {
          if (!(n instanceof Element)) return;
          visible.forEach(el => {if (el===n || n.contains(el)) {visible.delete(el);clearTimeout(timers.get(el));timers.delete(el);observer?.unobserve(el);}});
        });
      } else {
        const el = record.target;
        if (record.attributeName === 'open' && el.matches('bb-size-dialog dialog,quick-add-modal')) {
          if (el.hasAttribute('open')) use(el,'open',{},el.matches('quick-add-modal')?'quick_view':'size_guide');
        }
        if (record.attributeName === 'aria-busy' && el.matches('.bb-sf__results') && el.getAttribute('aria-busy') === 'false') {
          const count = el.querySelectorAll('a.bb-sf__item').length;
          const finder = el.closest('bb-size-finder');
          use(el,finder.querySelector('.bb-sf__retry')?.hidden===false?'results_error':'results_loaded',{result_count:count,selected_size:size(finder.querySelector('[data-size][aria-pressed="true"]')?.dataset.size)},'size_finder');
        }
      }
    });
  });
  mutations.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['open','aria-busy']});
  scan();
  // Correlate confirmed native cart results with the feature that initiated them.
  // This custom event is NOT add_to_cart and never carries revenue.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    const outcome = result => {
      if (!pendingCart || Date.now()-pendingCart.at>15000) {pendingCart=null;return;}
      const {at,feature_action,...params}=pendingCart;pendingCart=null;
      send('bb_feature_result',{...params,feature_action:'add_to_cart',feature_result:result});
    };
    subscribe(PUB_SUB_EVENTS.cartUpdate, data => {
      if (data?.source === 'product-form' || data?.source === 'bb-up-close') {
        if (pendingCart?.variant_id && data.productVariantId && String(data.productVariantId)!==String(pendingCart.variant_id)) return;
        outcome('success');
      }
    });
    if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError,()=>outcome('error'));
  }
  document.addEventListener('bb:feature-result',event=> {
    if (event.detail?.feature === 'up_close' && event.detail?.result === 'error' && pendingCart?.feature_name === 'up_close') {
      const {at,feature_action,...params}=pendingCart;pendingCart=null;
      send('bb_feature_result',{...params,feature_action:'add_to_cart',feature_result:'error'});
    }
  });
  // Consent and Google's existing loader may arrive after the theme bundle.
  let tries=0;
  const boot=()=> {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures && tries===0) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>start());
    }
    start();
    if (!themeViewed && ++tries<30) setTimeout(boot,1000);
  };
  boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-pdp-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-enhancements')) {
  customElements.define('bb-product-enhancements', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root || this.root.dataset.updateUrl !== 'true' || this.root.dataset.originalSection) return;
      this.bar = this.querySelector('.bb-pdp-sticky');
      this.buy = this.querySelector('[data-bb-buy]');
      this.info = this.root.querySelector('.product__info-container');
      this.primary = this.root.querySelector('.product-form__submit');
      if (!this.primary || !this.bar) return;
      this.abort = new AbortController();
      this.root.addEventListener('click', event => {
        const guide = event.target.closest('[data-bb-guide]');
        if (guide) {
          const details = this.root.querySelector(guide.getAttribute('href'));
          if (details) { event.preventDefault(); details.open = true; details.scrollIntoView({block:'center',behavior:'auto'}); details.querySelector('summary')?.focus({preventScroll:true}); }
        }
        const mix = event.target.closest('[data-bb-mix]');
        if (mix) {
          const link = this.root.querySelector('.product__description a[href*="wa.me"]');
          if (link) { event.preventDefault(); link.scrollIntoView({block:'center',behavior:'auto'}); link.focus({preventScroll:true}); }
        }
      }, {signal:this.abort.signal});
      this.querySelector('[data-bb-options]').addEventListener('click', () => {
        const target = this.root.querySelector('variant-selects') || this.primary;
        target.scrollIntoView({block:'center',behavior:'auto'});
        (target.querySelector('input:checked + label, select') || this.primary).focus({preventScroll:true});
      }, {signal:this.abort.signal});
      this.buy.addEventListener('click', () => {
        if (this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true') return;
        this.primary.click();
        this.sync();
      }, {signal:this.abort.signal});
      this.root.addEventListener('change', () => this.schedule(), {signal:this.abort.signal});
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.info, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','value']});
      this.intersection = new IntersectionObserver(entries => {
        this.bar.hidden = entries[0].isIntersecting && entries[0].intersectionRatio > .5;
      }, {threshold:[0,.5,1]});
      this.intersection.observe(this.primary);
      this.updateViewport = () => {
        const preview = document.getElementById('PBarNextFrameWrapper');
        const rect = preview?.getBoundingClientRect();
        const visible = rect && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && getComputedStyle(preview).display !== 'none';
        const offset = visible ? Math.min(rect.height, window.innerHeight * .5) : 0;
        document.documentElement.style.setProperty('--bb-preview-offset', offset + 'px');
        if (preview && this.preview !== preview) {
          this.preview = preview;
          this.previewResize?.disconnect();
          this.previewResize = new ResizeObserver(this.updateViewport);
          this.previewResize.observe(preview);
          preview.addEventListener('toggle', this.updateViewport, {signal:this.abort.signal});
        }
      };
      this.previewWatch = new MutationObserver(this.updateViewport);
      this.previewWatch.observe(document.body, {childList:true});
      window.addEventListener('resize', this.updateViewport, {signal:this.abort.signal});
      window.visualViewport?.addEventListener('resize', this.updateViewport, {signal:this.abort.signal});
      this.updateViewport();
      this.sync();
    }
    schedule() { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); }
    sync() {
      this.primary = this.root.querySelector('.product-form__submit') || this.primary;
      const priceBox = this.root.querySelector('[id^="price-"]');
      const currentPrice = priceBox?.querySelector('.price--on-sale .price-item--sale') || priceBox?.querySelector('.price__regular .price-item--regular');
      const price = priceBox?.classList.contains('hidden') ? '' : currentPrice?.textContent.trim() || '';
      const options = [...this.root.querySelectorAll('variant-selects input:checked')].filter(el => el.closest('fieldset')?.querySelectorAll('input[type=radio]').length > 1).sort((a,b) => Number((b.dataset.optionName || '').toLowerCase() === 'size') - Number((a.dataset.optionName || '').toLowerCase() === 'size')).map(el => el.value);
      this.root.querySelectorAll('variant-selects select').forEach(el => options.push(el.selectedOptions[0]?.textContent.trim()));
      const quantity = this.root.querySelector('.quantity__input')?.value || '1';
      const blocked = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true';
      const label = this.primary.querySelector('span:not(.loading__spinner)')?.textContent.trim() || this.primary.textContent.trim();
      this.buy.disabled = blocked;
      this.buy.textContent = label;
      this.querySelector('[data-bb-sticky-price]').textContent = price;
      this.querySelector('[data-bb-sticky-choice]').textContent = [options.join(' · '),this.dataset.quantity+' '+quantity].filter(Boolean).join(' · ');
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); this.previewResize?.disconnect(); this.previewWatch?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-plp-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-size-browser')) {
  customElements.define('bb-size-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-bb-filter]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (typeof FacetFiltersForm === 'undefined') return;
        event.preventDefault();
        const url = new URL(link.href);
        FacetFiltersForm.renderPage(url.search.slice(1));
      });
    }
  });
}
if (!customElements.get('bb-collection-card')) {
  customElements.define('bb-collection-card', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const toggle = this.querySelector('[data-bb-image-toggle]');
      if (!toggle) return;
      toggle.hidden = false;
      toggle.addEventListener('click', () => {
        const second = this.classList.toggle('bb-card--second');
        toggle.setAttribute('aria-pressed', String(second));
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-product-discovery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-discovery')) {
  customElements.define('bb-product-discovery', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root || this.root.dataset.updateUrl !== 'true' || this.root.dataset.originalSection) return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== this.dataset.section) return;
        const next = [...event.data.html.querySelectorAll('bb-product-discovery')].find(el => el.dataset.mode === this.dataset.mode && el.dataset.section === this.dataset.section);
        if (next) { this.innerHTML = next.innerHTML; this.dataset.size = next.dataset.size; this.removeAttribute('aria-busy'); }
      });
      this.abort = new AbortController();
      this.root.addEventListener('change', event => {
        if (event.target.closest('variant-selects')) { this.setAttribute('aria-busy', 'true'); if (this.dataset.mode === 'stock') this.innerHTML = ''; }
      }, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.unsubscribe?.(); this.abort?.abort(); }
  });
}
if (!customElements.get('bb-size-dialog')) {
  customElements.define('bb-size-dialog', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      if (!this.root || this.root.dataset.updateUrl !== 'true' || this.root.dataset.originalSection) return;
      this.source = document.getElementById(this.dataset.source);
      this.dialog = this.querySelector('dialog');
      this.content = this.source?.querySelector('.accordion__content');
      if (!this.content || !this.dialog.showModal) return;
      this.abort = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-bb-chart-variants]').textContent);
      this.sizePicker = this.querySelector('[data-bb-chart-size-select]');
      this.sizePicker.addEventListener('change', () => this.selectSize(this.sizePicker.value, 'selector'), {signal:this.abort.signal});
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.data.sectionId !== this.root.dataset.section) return;
        clearTimeout(this.pendingTimer);
        this.pending = false;
        if (this.dialog.open) {
          this.querySelector('[data-bb-chart-status]').hidden = true;
          this.syncChart(event.data.variant?.options[Number(this.dataset.sizeIndex)] || '');
          if (this.returnToSummary) this.showSelection();
          this.returnToSummary = false;
        }
      });
      this.content.addEventListener('click', event => {
        const tab = event.target.closest('.srv-tab');
        if (tab) this.renderSummary(tab.dataset.p);
        const row = event.target.closest('tr[data-bb-chart-row]');
        if (row && !event.target.closest('.bb-chart-size-choice:disabled')) this.selectSize(row.dataset.bbChartRow, 'table');
      }, {signal:this.abort.signal});
      this.content.addEventListener('keydown', event => {
        if (!event.target.matches('.bb-chart-size-choice')) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const buttons = [...event.target.closest('table').querySelectorAll('.bb-chart-size-choice:not(:disabled)')];
          const next = buttons[buttons.indexOf(event.target) + (event.key === 'ArrowDown' ? 1 : -1)];
          next?.focus();
        }
      }, {signal:this.abort.signal});
      this.root.addEventListener('click', event => {
        const link = event.target.closest('[data-bb-guide]');
        const summary = event.target.closest('summary');
        if ((link && link.hash === '#' + this.dataset.source) || (summary && summary.parentElement === this.source)) {
          event.preventDefault(); event.stopImmediatePropagation(); this.open(event.target.closest('a,summary'));
        }
      }, {capture:true,signal:this.abort.signal});
      this.querySelector('[data-bb-chart-close]').addEventListener('click', () => this.dialog.close(), {signal:this.abort.signal});
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close(); } }, {signal:this.abort.signal});
      this.dialog.addEventListener('close', () => this.restore(), {signal:this.abort.signal});
    }
    open(trigger) {
      if(this.dialog.open) return;
      this.trigger = trigger;
      this.placeholder = document.createComment('BB original size chart position');
      this.content.before(this.placeholder);
      this.querySelector('[data-bb-chart-body]').append(this.content);
      this.content.querySelectorAll('.srv-panel table').forEach(table => {
        const rows = [...table.querySelectorAll('tbody tr')];
        const rowL = rows.find(row => row.cells[0]?.textContent.trim() === 'L');
        if (!rowL || rows.some(row => row.cells[0]?.textContent.trim() === 'M')) return;
        const rowM = rowL.cloneNode(true);
        rowM.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        rowM.cells[0].textContent = 'M';
        [...rowM.cells].slice(1).forEach(cell => {
          const value = Number(cell.textContent.trim());
          if (Number.isFinite(value)) cell.textContent = String(value - 1);
        });
        rowL.before(rowM);
      });
      this.content.querySelectorAll('.srv-sg p').forEach(p => {
        if (p.textContent.includes('Sizes L to 12XL')) p.textContent = p.textContent.replace('Sizes L to 12XL', 'Sizes M to 12XL');
      });
      const master = this.content.querySelector('.srv-master');
      if (master && !master.querySelector('.bb-chart-mobile-groups')) {
        const groups = document.createElement('div');
        groups.className = 'bb-chart-mobile-groups';
        this.content.querySelectorAll('.srv-panel:not(.srv-master)').forEach(panel => {
          const table = panel.querySelector('table');
          const label = [...this.content.querySelectorAll('.srv-tab')].find(tab => tab.dataset.p === panel.dataset.panel);
          if (!table || !label) return;
          const group = document.createElement('section');
          const heading = document.createElement('h3');
          heading.textContent = label.textContent;
          const frame = document.createElement('div');
          frame.className = 'srv-scroll';
          const copy = table.cloneNode(true);
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          copy.setAttribute('aria-label', label.textContent.trim());
          frame.append(copy);
          group.append(heading, frame);
          groups.append(group);
        });
        if (groups.children.length) master.append(groups);
      }
      this.content.querySelectorAll('tbody tr').forEach(row => {
        if (!row.cells[0] || row.dataset.bbChartRow) return;
        const size = row.cells[0].textContent.trim();
        row.dataset.bbChartRow = size;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bb-chart-size-choice';
        button.dataset.bbChartSelect = size;
        button.textContent = size;
        const state = document.createElement('span');
        state.className = 'bb-chart-size-state';
        row.cells[0].replaceChildren(button,state);
      });
      this.activeTab = this.dataset.tab;
      this.querySelector('[data-bb-chart-status]').hidden = true;
      this.syncChart(this.currentVariant()?.options[Number(this.dataset.sizeIndex)] || '');
      this.dialog.showModal();
      this.querySelector('.bb-size-dialog__body').scrollTop = 0;
      const tab = [...this.content.querySelectorAll('.srv-tab')].find(el => el.dataset.p === this.dataset.tab);
      tab?.click();
      this.querySelector('[data-bb-chart-close]').focus();
    }
    normalize(value) { return String(value || '').trim().toUpperCase().replace('XXXL','3XL').replace('XXL','2XL'); }
    currentVariant() {
      try { return JSON.parse(this.root.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); }
      catch { return null; }
    }
    sizeOption(size) {
      return [...this.root.querySelectorAll('variant-selects [data-option-name]')].find(input => input.dataset.optionName.toLowerCase() === 'size' && this.normalize(input.value) === this.normalize(size));
    }
    matchingVariant(size) {
      const current = this.currentVariant();
      if (!current || this.dataset.sizeIndex === '') return null;
      return this.variants.find(variant => variant.options.every((value,index) => index === Number(this.dataset.sizeIndex) ? this.normalize(value) === this.normalize(size) : value === current.options[index]));
    }
    syncChart(size) {
      this.selectedChartSize = size;
      const values = [...new Set(this.variants.map(variant => variant.options[Number(this.dataset.sizeIndex)]))].filter(Boolean);
      this.sizePicker.replaceChildren(...values.map(value => {
        const option = document.createElement('option');
        const variant = this.matchingVariant(value);
        const input = this.sizeOption(value);
        const available = Boolean(variant?.available && input && !input.disabled);
        option.value = value;
        option.textContent = value + (available ? '' : ' — ' + (variant ? this.dataset.soldLabel : this.dataset.absentLabel));
        option.disabled = !available;
        option.selected = this.normalize(value) === this.normalize(size);
        return option;
      }));
      if (!size) this.sizePicker.selectedIndex = -1;
      this.sizePicker.disabled = Boolean(this.pending);
      this.content.querySelectorAll('tr[data-bb-chart-row]').forEach(row => {
        const value = row.dataset.bbChartRow;
        const variant = this.matchingVariant(value);
        const input = this.sizeOption(value);
        const available = Boolean(variant?.available && input && !input.disabled);
        const selected = this.normalize(value) === this.normalize(size);
        const button = row.querySelector('.bb-chart-size-choice');
        button.disabled = !available || this.pending;
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', this.dataset.selectLabel.replace('[size]', value) + (!available ? ' — ' + (variant ? this.dataset.soldLabel : this.dataset.absentLabel) : ''));
        row.classList.toggle('bb-chart-selected',selected);
        row.classList.toggle('bb-chart-selectable',available && !this.pending);
        row.querySelector('.bb-chart-size-state').textContent = available ? '' : variant ? this.dataset.soldLabel : this.dataset.absentLabel;
      });
      this.renderSummary(this.activeTab || this.dataset.tab);
    }
    showSelection() {
      this.sizePicker.focus({preventScroll:true});
      this.querySelector('.bb-size-dialog__body').scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    selectSize(size, source) {
      if (this.pending) return;
      const input = this.sizeOption(size);
      const variant = this.matchingVariant(size);
      if (!input || input.disabled || !variant?.available) return;
      if (variant.id === this.currentVariant()?.id) { if (source === 'table') this.showSelection(); return; }
      this.returnToSummary = source === 'table';
      this.pending = true;
      const status = this.querySelector('[data-bb-chart-status]');
      status.textContent = this.dataset.updatingLabel.replace('[size]',size);
      status.hidden = false;
      this.syncChart(this.selectedChartSize);
      this.pendingTimer = setTimeout(() => {
        this.pending = false;
        if (!this.dialog.open) return;
        this.returnToSummary = false;
        status.textContent = this.dataset.errorLabel;
        this.syncChart(this.currentVariant()?.options[Number(this.dataset.sizeIndex)] || '');
      },10000);
      if (input.tagName === 'OPTION') {
        input.parentElement.value = input.value;
        input.parentElement.dispatchEvent(new Event('change',{bubbles:true}));
      } else {
        input.checked = true;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    renderSummary(activeTab) {
      this.activeTab = activeTab;
      const summary = this.querySelector('[data-bb-chart-summary]');
      const normalize = value => value.trim().toUpperCase().replace('XXXL','3XL').replace('XXL','2XL');
      summary.replaceChildren();
      const heading = document.createElement('h3');
      heading.textContent = this.dataset.summaryLabel.replace('[size]', this.selectedChartSize || '');
      summary.append(heading);
      let groups = 0;
      this.content.querySelectorAll('.srv-panel:not(.srv-master)').forEach(panel => {
        if (activeTab !== 'all' && panel.dataset.panel !== activeTab) return;
        const row = [...panel.querySelectorAll('tbody tr')].find(row => normalize(row.dataset.bbChartRow || row.cells[0]?.textContent || '') === normalize(this.selectedChartSize || ''));
        if (!row) return;
        const headers = [...panel.querySelectorAll('thead tr:last-child th')].slice(1);
        if (headers.length !== row.cells.length - 1) return;
        const label = [...this.content.querySelectorAll('.srv-tab')].find(tab => tab.dataset.p === panel.dataset.panel);
        const group = document.createElement('section');
        const title = document.createElement('h4'); title.textContent = label?.textContent.trim() || '';
        const list = document.createElement('dl');
        headers.forEach((header,index) => {
          const cell = document.createElement('div');
          const term = document.createElement('dt'); term.textContent = header.textContent.trim();
          const value = document.createElement('dd'); value.textContent = row.cells[index + 1].textContent.trim() + '″';
          cell.append(term,value);list.append(cell);
        });
        group.append(title,list);summary.append(group);groups++;
      });
      summary.hidden = groups === 0;
      this.querySelector('[data-bb-chart-units]').hidden = groups === 0;
      this.querySelector('[data-bb-chart-unavailable]').hidden = groups > 0;
    }
    restore() {
      this.returnToSummary = false;
      if (this.placeholder?.parentNode) this.placeholder.replaceWith(this.content);
      this.content?.querySelectorAll('.bb-chart-selected').forEach(row=>row.classList.remove('bb-chart-selected'));
      this.trigger?.focus({preventScroll:true});
    }
    disconnectedCallback() { this.unsubscribe?.(); clearTimeout(this.pendingTimer); this.abort?.abort(); if(this.dialog?.open) this.dialog.close(); this.restore?.(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
